import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import { languages } from "../../constants/languages";
import Toolbar from "@material-ui/core/Toolbar";
import EditPouleContainer from "../../containers/structure/EditPouleContainer";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import EditBracketContainer from "../../containers/structure/EditBracketContainer";
import EditFaseContainer from "../../containers/structure/EditFaseContainer";
import DeleteFaseContainer from "../../containers/structure/DeleteFaseContainer";
import DivideTeamsContainer from "../../containers/structure/DivideTeamsContainer";
import { DragDropContext, Droppable } from "react-beautiful-dnd";

const styles = (theme) => ({
  poulesRoot: {
    marginLeft: 2,
    marginRight: theme.spacing(5),
    [theme.breakpoints.down("xs")]: {
      marginLeft: 2,
      marginRight: theme.spacing(4),
    },
  },
});

class Poules extends Component {
  state = {
    structureObjectsTemp: undefined,
  };

  onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }
    const structureObjects = this.props.structureObjects
      .slice()
      .sort((a, b) => {
        if (a.indexNum > b.indexNum) {
          return 1;
        } else if (a.indexNum < b.indexNum) {
          return -1;
        } else if (a.num > b.num) {
          return 1;
        } else if (a.num < b.num) {
          return -1;
        } else {
          return 0;
        }
      });
    const [removed] = structureObjects.splice(result.source.index, 1);
    structureObjects.splice(result.destination.index, 0, removed);
    const db = window.firebase.firestore();
    let batch = db.batch();
    const poulesRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("poules");
    const bracketsRef = db
      .collection("tournaments")
      .doc(this.props.tournament[".key"])
      .collection("brackets");

    let structureObjectsTemp = [];
    structureObjects.forEach((l, i) => {
      let o = structureObjects[i];
      o["indexNum"] = i;
      structureObjectsTemp.push(o);
      let refToUpdate = poulesRef.doc(l.id);
      if (o.size) {
        refToUpdate = bracketsRef.doc(l.id);
      }
      batch.update(refToUpdate, { indexNum: i });
    });
    this.props.setStructureObjectsTemp(structureObjectsTemp);
    if (this.props.tournament.ia) {
      batch.set(db.collection("cacheUpdatesApp").doc(), {
        tournamentId: this.props.tournament[".key"],
        status: "pending",
        timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      });
    }
    batch.commit().catch((error) => {
      console.log(error.message);
      this.props.setStructureObjectsTemp(undefined);
    });
  };

  render() {
    return (
      <div style={{ minHeight: 20, minWidth: 240 }}>
        <Toolbar style={{ paddingLeft: 0 }}>
          <Typography variant="h6">
            {this.props.faseObject
              ? this.props.faseObject.name
              : languages.structure.fase + " " + (this.props.fase + 1)}
          </Typography>
          <EditFaseContainer
            tournament={this.props.tournament}
            division={this.props.division}
            fase={this.props.fase}
            faseObject={this.props.faseObject}
            tournamentStatus={this.props.tournamentStatus}
            toggleFinishedDialog={this.props.toggleFinishedDialog}
            structureObjects={this.props.structureObjects.slice()}
            poules={this.props.poules}
            allBracketsForPhase={this.props.allBracketsForPhase}
            bracketsByKey={this.props.bracketsByKey}
          />
          {this.props.fase === 0 && (
            <DivideTeamsContainer
              tournament={this.props.tournament}
              teams={this.props.teams}
              structureObjects={this.props.structureObjects}
              poules={this.props.poules}
              resultSpotsAll={this.props.resultSpotsAll}
              maxTeams={this.props.maxTeams}
              toggleUpgradeDialog={this.props.toggleUpgradeDialog}
              poulesByKey={this.props.poulesByKey}
              subBrackets={this.props.subBrackets}
              allBracketsForPhase={this.props.allBracketsForPhase}
            />
          )}
          {this.props.fase !== 0 &&
            this.props.fase ===
              (this.props.division.fases || [true]).length - 1 &&
            this.props.poules.length === 0 && (
              <div>
                <DeleteFaseContainer
                  tournament={this.props.tournament}
                  division={this.props.division}
                  tournamentStatus={this.props.tournamentStatus}
                  toggleFinishedDialog={this.props.toggleFinishedDialog}
                  fase={this.props.fase}
                />
              </div>
            )}
          <div style={{ flex: "1 1 10%" }} />
          {/* {this.props.fase === (this.props.division.fases || [true]).length - 1 &&
        this.props.poules.length > 0 && (
          <div>
            <EditFaseContainer
              tournament={this.props.tournament}
              division={this.props.division}
            />
          </div>
        )} */}
        </Toolbar>
        <div className={this.props.classes.poulesRoot}>
          <DragDropContext onDragEnd={this.onDragEnd}>
            <Droppable droppableId="structureDrop">
              {(provided, snapshot) => {
                return (
                  <div ref={provided.innerRef}>
                    {this.props.structureElements}
                    {provided.placeholder}
                  </div>
                );
              }}
            </Droppable>
          </DragDropContext>
          <div style={{ marginBottom: 10 }}>
            <EditPouleContainer
              tournament={this.props.tournament}
              division={this.props.division}
              poules={this.props.poules}
              fase={this.props.fase}
              poulesByKey={this.props.poulesByKey}
              bracketsByKey={this.props.bracketsByKey}
              userStatus={this.props.userStatus}
              tournamentStatus={this.props.tournamentStatus}
              toggleFinishedDialog={this.props.toggleFinishedDialog}
              user={this.props.user || {}}
              toggleUpgradeDialog={this.props.toggleUpgradeDialog}
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <EditBracketContainer
              tournament={this.props.tournament}
              division={this.props.division}
              brackets={this.props.brackets}
              poules={this.props.poules}
              fase={this.props.fase}
              poulesByKey={this.props.poulesByKey}
              bracketsByKey={this.props.bracketsByKey}
              userStatus={this.props.userStatus}
              tournamentStatus={this.props.tournamentStatus}
              toggleFinishedDialog={this.props.toggleFinishedDialog}
              toggleUpgradeDialog={this.props.toggleUpgradeDialog}
              user={this.props.user}
            />
          </div>
          <div style={{ marginBottom: 10 }}>
            <EditPouleContainer
              tournament={this.props.tournament}
              division={this.props.division}
              poules={this.props.poules}
              fase={this.props.fase}
              singleMatch={true}
              poulesByKey={this.props.poulesByKey}
              bracketsByKey={this.props.bracketsByKey}
              userStatus={this.props.userStatus}
              tournamentStatus={this.props.tournamentStatus}
              toggleFinishedDialog={this.props.toggleFinishedDialog}
              user={this.props.user || {}}
              toggleUpgradeDialog={this.props.toggleUpgradeDialog}
            />
          </div>
        </div>
      </div>
    );
  }
}

Poules.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Poules);
